module.exports = __webpack_public_path__ + "img/quotes-grey.4538df55.svg";